'use strict';
import { Injectable} from 'ng-metadata/core';

const _replace= require('lodash/replace');
const _truncate = require('lodash/truncate');

@Injectable()
export class StringUtils {
	public isEmpty(str){
		return (!str || 0 === str.length);
	}

	public removeSpaceEncodingFromString(str: string): string{
		return _replace(str, new RegExp('%20', 'g') , '');
	}

	/**
	 * Shortening long string.
	 * adding '...' at the end.
	 * @param str
	 * @param length = max length of the result string
	 * @returns string
	 */
	public abbreviate(str, length = 26):string {
		let truncOptions = {
			'length':length,
			'separator': /\s/
		};

		return _truncate(str, truncOptions);
	}
    
    /* taken from https://ourcodeworld.com/articles/read/188/encode-and-decode-html-entities-using-pure-javascript */
    public encode(str) {
        let buf = [];
        
        for (let i=str.length-1;i>=0;i--) {
            buf.unshift(['&#', str[i].charCodeAt(), ';'].join(''));
        }
        
        return buf.join('');
    }

    /* taken from https://ourcodeworld.com/articles/read/188/encode-and-decode-html-entities-using-pure-javascript */
    public decode(str) {
        return str.replace(/&#(\d+);/g, (match, dec) => {
            return String.fromCharCode(dec);
        });
    }

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/stringUtils.service.ts